import { defineMessages } from 'react-intl';

type MessageKeys = 'sharedChatContinuationPill';

const messages: Record<MessageKeys, { id: string; defaultMessage: string; description?: string }> =
	defineMessages({
		sharedChatContinuationPill: {
			id: 'conversation-assistant.chat-history.shared-chat-continuation-pill.SharedChatContinuationPill.messages.sharedChatContinuationPill',
			defaultMessage: 'You continued in a new chat',
			description:
				"Pill shown at the boundary between a shared chat snapshot and the user's continued conversation.",
		},
	});

export default messages;
